/* Vendtech (item 3.4): adiciona ao carrinho pelo tamanho escolhido no card. */
(function () {
  if (window.VTCardSizesLoaded) return;
  window.VTCardSizesLoaded = true;
  document.addEventListener('click', async function (e) {
    var toggle = e.target.closest('[data-vt-sizes-toggle]');
    if (toggle) {
      e.preventDefault();
      var box = toggle.closest('[data-vt-sizes]');
      var aberto = box.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', aberto ? 'true' : 'false');
      document.querySelectorAll('[data-vt-sizes].is-open').forEach(function (b) { if (b !== box) { b.classList.remove('is-open'); } });
      return;
    }
    var botao = e.target.closest('[data-vt-size]');
    if (!botao || botao.disabled) return;
    e.preventDefault();
    var original = botao.textContent;
    botao.classList.add('is-loading');
    botao.disabled = true;
    try {
      var r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(botao.getAttribute('data-vt-size')), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }) });
      var estado = await r.json();
      if (!r.ok || estado.status) throw new Error(estado.description || 'erro');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && estado.sections) {
        estado.id = estado.items && estado.items[0] ? estado.items[0].id : estado.id;
        drawer.renderContents(estado);
        document.dispatchEvent(new CustomEvent('cartUpdated'));
      } else {
        window.location.href = '/cart';
      }
      botao.textContent = '✓';
      var box2 = botao.closest('[data-vt-sizes]');
      setTimeout(function () { botao.textContent = original; if (box2) box2.classList.remove('is-open'); }, 1500);
    } catch (err) {
      botao.textContent = original;
      alert('Não foi possível adicionar este tamanho. Tente pela página do produto.');
    } finally {
      botao.classList.remove('is-loading');
      botao.disabled = false;
    }
  });
})();